import { createRoot } from 'react-dom/client';
import { Suspense } from 'react';
import { ContactUsProps, ContactUs } from './pages/contactUs';
import { chat, createI18n, I18nProvider } from '@bino/utils/i18next';

const i18n = createI18n(chat);

export const renderApp = (id: string, props: ContactUsProps) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    root.render(
        <Suspense>
            <I18nProvider i18n={i18n}>
                <ContactUs {...props} />
            </I18nProvider>
        </Suspense>,
    );
};
